import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const ProductsChart = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Top 5 Culturas</h5>
        <p>Sem dados disponíveis.</p>
      </div>
    );
  }

  const chartData = data.map(product => ({
    name: product?.name || '',
    value: Number(product?.stock) || 0
  })).filter(item => item.value > 0);

  if (chartData.length === 0) {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Top 5 Culturas</h5>
        <p>Sem dados válidos para exibir.</p>
      </div>
    );
  }

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

  const formatTooltip = (value) => {
    return `${Number(value).toFixed(0)} kg`;
  };

  return (
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <h5>Top 5 Culturas</h5>
      <ResponsiveContainer width="100%" height={450}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={formatTooltip} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProductsChart;
